import { useSearchParams } from 'react-router-dom'
import { ELITE_PLANS_DISPLAY_MODE_QUERY_PARAM } from '../constants/planIds'

/** True when the webview URL carries `displayMode=dark`. */
export function useElitePlansIsDarkMode() {
  const [searchParams] = useSearchParams()
  return searchParams.get(ELITE_PLANS_DISPLAY_MODE_QUERY_PARAM) === 'dark'
}
